import { defineStore } from 'pinia'
import { reactive } from 'vue'

interface IStorePromises {
	[key: string]: Promise<ICMSLocationContentModel[] | null> | null
}

export interface ISubpages {
	[key: string]: ICMSLocationContentModel[] | null
}

export interface ISubpagesContentState {
	pageSections: ISubpages | null
}

export interface ISubpagesContentStore {
	readonly state: {
		pageSections: ISubpages | null
	}
	fetchPageSections: (subpage: string) => Promise<ICMSLocationContentModel[] | null>
}

export const useSubpagesContentStore = defineStore('subpagesContentStore', (): ISubpagesContentStore => {
	const _state = reactive<ISubpagesContentState>({
		pageSections: null,
	})

	const promises: IStorePromises = {}

	const fetchPageSections = async (subpage: string) => {
		try {
			if (_state.pageSections && _state.pageSections[subpage] && _state.pageSections[subpage].length > 0) {
				return _state.pageSections[subpage]
			}

			if (promises?.[subpage]) {
				return promises[subpage]
			}

			promises[subpage] = (async () => {
				const response = await ApiService.fetchSubpageSections(subpage)
				if (response) {
					_state.pageSections = { ..._state.pageSections, [subpage]: response.data }
				} else {
					_state.pageSections = null
				}

				return _state.pageSections ? _state.pageSections[subpage] : null
			})()

			return await promises[subpage]
		} catch (error) {
			logger.log(error)
			return null
		}
	}

	return {
		state: _state,
		fetchPageSections,
	}
})
